import { FC } from 'react';
import { FormLabel as MuiFormLabel } from '@mui/material';
import { spacing } from '@mui/system';
import { styled } from '@mui/material/styles';
import { css, SerializedStyles } from '@emotion/react';
import { LabelMapper } from '../../common/mapper/LabelMapper';
import { BaseFormHeader } from './model/BaseFormHeader';

const StyledFormLabel = styled(MuiFormLabel)<BaseFormHeader>`
  ${spacing}
  ${({ theme, fontWeight, color, fontSize }): SerializedStyles => css`
    color: ${LabelMapper.toColor(color ?? 'primary', theme)};
    font-weight: ${fontWeight ? fontWeight : 500};
    font-size: ${fontSize ? fontSize : '1rem'};
  `}
`;

// TODO: [Saman M]: Rename the UI component to `FormLabel2` to maintain consistency with the MUI naming convention
export const FormHeader2: FC<BaseFormHeader> = ({ color = 'primary', component = 'h6', my = 2, ...props }) => (
  <StyledFormLabel my={my} color={color} component={component} {...props} />
);
